"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceLength = exports.mapErrors = exports.isValidInternalLink = exports.isValidExternalLink = exports.getBorderColor = exports.foldersToTree = void 0;
var _cccisdColorPicker = require("cccisd-color-picker");
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var reduceLength = function reduceLength(str) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
  if (str.length <= length) {
    return str;
  }
  var arr = str.split('.');
  var extension = arr.length > 1 ? '.' + arr.pop() : '';
  var name = arr.join('');
  var lengthRest = length - extension.length - 1;
  var firstPart = Math.ceil(lengthRest / 2);
  var lastPart = Math.floor(lengthRest / 2);
  return name.slice(0, firstPart) + '…' + name.slice(-lastPart) + extension;
};
exports.reduceLength = reduceLength;
var mapErrors = function mapErrors() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mapKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = Object.keys(errors);
  var result = {};
  keys.forEach(function (key) {
    var value = typeof errors[key] === 'string' ? errors[key] : errors[key].join('\n');
    key = mapKeys[key] || key;
    if (!result[key]) {
      result[key] = value;
    } else {
      result[key] += '\n' + value;
    }
  });
  return result;
};
exports.mapErrors = mapErrors;
var foldersToTree = function foldersToTree(folders) {
  var result = [];
  var populateBranch = function populateBranch(branch, tree) {
    var leaf = branch.shift();
    var node = tree.find(function (item) {
      return item.name === leaf;
    });
    if (!node) {
      node = {
        name: leaf,
        children: []
      };
      tree.push(node);
    }
    if (branch.length > 0) {
      populateBranch(branch, node.children);
    }
  };
  folders.map(function (folder) {
    return folder.replace(/^\//, '').split('/');
  }).forEach(function (arr) {
    return populateBranch(arr, result);
  });
  return result;
};
exports.foldersToTree = foldersToTree;
var isValidExternalLink = function isValidExternalLink(link) {
  var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&%'()*+,;=.]+$/;
  return regex.test(link);
};
exports.isValidExternalLink = isValidExternalLink;
var isValidInternalLink = function isValidInternalLink(link) {
  var regex = /^\/([^/].+)?$/;
  return regex.test(link);
};
exports.isValidInternalLink = isValidInternalLink;
var getBorderColor = function getBorderColor(colorStr) {
  return (0, _color["default"])((0, _cccisdColorPicker.getColor)(colorStr)).lightness(95);
};
exports.getBorderColor = getBorderColor;